import React, { useEffect, useState } from 'react';
import { DocumentItem } from './types/DocumentItem';
import { useParams } from 'react-router-dom';
import DocumentsTableConfigurator from './helpers/DocumentsTableConfigurator';
import { DataTable, emptyDataTable } from '../../../../../core/components/Table/types/DataTable';
import ApiProvider from '../../../../../core/api/ApiProvider';
import { InfoMessageService, TranslationService } from '../../../../../core/services';
import { Loader, Table } from '../../../../../core/components';
import Status from '../../../../../core/types/Status';

const Documents = () => {
  const { caseNumber, tenantUId } = useParams() as { caseNumber: string; tenantUId: string; };
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [model, setModel] = useState<DataTable<DocumentItem>>({ ...emptyDataTable });

  const getDocuments = async () => {
    return await ApiProvider.post<Status<DataTable<DocumentItem>>>(
      `DocumentsModule/GetDocuments?CaseNo=${caseNumber}`
    );
  };

  const isDocumentExists = async (documentId: string, fileName: string) => {
    return await ApiProvider.get<Status<any>>(
      `DocumentsModule/IsDocumentExists/${documentId}/${fileName}/${caseNumber}`
    );
  };

  const downloadDocument = async (documentId: string) => {
    try {
      setIsLoading(true);

      const fileName = model.dataRows.find(element => element.DocumentId == documentId)!.FileName;
      const data = await isDocumentExists(documentId, fileName);

      if (data.success) {
          await ApiProvider.downloadFile(
            `DocumentsModule/DownloadDocument/${documentId}/${fileName}/${caseNumber}`
          );
      } else {
        InfoMessageService.error(TranslationService.translate('FileError'));
      }
    } catch {
      InfoMessageService.error(TranslationService.translate('DocumentsError'));
    } finally {
      setIsLoading(false);
    }
  };

  const fetchModel = async () => {
    try {
      setIsLoading(true);
      const data = await getDocuments();
      if (data.success) {
        setModel(data.data);
      } else {
        InfoMessageService.error('DocumentsError');
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchModel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading && <Loader opacity={0.4} />}
      <Table
        keyField="DocumentId"
        headers={DocumentsTableConfigurator.getTableColumns(model, downloadDocument)}
        rows={model.dataRows}
        paginationProps={{
          hideSizePerPage: true,
          hidePageListOnlyOnePage: true,
        }}
        noDataIndication={NoDataIndication}
      />
    </>
  );
};

const NoDataIndication = () => {
  return (
      <div data-cy={'documents-no-data'}>
        <p>{TranslationService.translate('DocumentsNoDataTable')}</p>
      </div>
  );
};

export default Documents;
